import Checkbox from '../checkbox';
import Radio from '../radio';
import Row from './row';
import Intact from 'intact';
import Column from './column';
import {noop, isStringOrNumber, getTextByChildren, getRestProps, mapChildren} from '../utils';
import Spin from '../spin';
import Affix from '../affix';
import Tooltip from '../tooltip';
import Icon from '../icon';
import Button from '../button';
import {isInvisible} from './utils';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const normalize = Intact.normalize;

const {
    checkType, scheme, checkedKeys, data, rowKey, 
    className, fixHeader, noDataTemplate, disableRow,
    resizable, expandedKeys, type, _isSticky, stickHeader, stripe,
    style, rowClassName, children, sort, group, _scrollBarWidth,
    _scrollPosition, _hoverIndex, tooltipPosition,
    _paddingBottom, _isStickyScrollbar, stickScrollbar, loading,
    _isShowLeftRightMiddle, merge, childrenKey, indent,
    draggable, _dragKey, showIndeterminate
} = self.get();

let cols;
let currentVNode;
let _scheme;
let maxRows = 0;
let maxCols = 0;
let hasFixedLeft;
let hasFixedRight;

self.leftColumns = [];
self.rightColumns = [];

const TheadCreator = ({onlyLeft, onlyRight, refContainer, style}) => {
    const keys = {};
    const refLeftElement = (i) => i && self.leftColumns.push(i);
    const refLeft = (i) => i && self.leftColumns.push(i.element);
    const refRight = (i) => i && self.rightColumns.push(i.element);
    const ref = onlyLeft ? refLeft : onlyRight ? refRight : undefined;
    const tableColumns = [];

    cols = [];
    currentVNode = undefined;
    _scheme = {};
    maxCols = 0;
    maxRows = 0;

    let checkVNode;
    if (checkType === 'checkbox' || checkType === 'radio') {
        maxCols++;
        cols.push(h('col', {
        'style': function() {try {return ({width: self._getHeaderWidth('_$checked')} )} catch(e) {_e(e)}}.call($this)
    }, null, 'k-th-check'));
        checkVNode = currentVNode = h('th', {
        'minWidth': function() {try {return (40 )} catch(e) {_e(e)}}.call($this)
    }, function() {try {return (checkType === 'checkbox' )} catch(e) {_e(e)}}.call($this) ?
        h(Checkbox, {
            'value': function() {try {return (self.isCheckAll() )} catch(e) {_e(e)}}.call($this),
            'indeterminate': function() {try {return (showIndeterminate ? self.isCheckHalf() : undefined )} catch(e) {_e(e)}}.call($this),
            '_context': $this,
            'ev-click': function() {try {return (self._toggleCheckAll )} catch(e) {_e(e)}}.call($this)
        }) :
        undefined, _className(function() {try {return ({'k-invisible': onlyRight} )} catch(e) {_e(e)}}.call($this)), '_$checked', function() {try {return (onlyLeft ? refLeftElement : undefined )} catch(e) {_e(e)}}.call($this))
        tableColumns[0] = [checkVNode];
    }
    
    const beforeLoop = (layer) => {
        if (layer + 1 > maxRows) maxRows = layer + 1;
        if (!tableColumns[layer]) tableColumns[layer] = [];
    };
    const loop = (item, key, parent, layer, fixed, loopRecursiveCallback) => {
        if (!__u.isObject(item) || item.type /* is vNode */) {
            item = {title: item};
        }
        item.key = key;

        // if parent fixed, fix children
        if (fixed) {
            item.fixed = fixed;
        }

        const dragStart = self._dragStart;

        if (item.fixed === 'left') {
            hasFixedLeft = true;
        } else if (item.fixed === 'right') {
            hasFixedRight = true;
        }

        const invisible = isInvisible(onlyLeft, onlyRight, item);
        let vNode = h(Column, {
        ...function() {try {return (item )} catch(e) {_e(e)}}.call($this),
        '$parent': function() {try {return (self )} catch(e) {_e(e)}}.call($this),
        'value': function() {try {return (self.get(`group.${key}`) )} catch(e) {_e(e)}}.call($this),
        'invisible': function() {try {return (invisible )} catch(e) {_e(e)}}.call($this),
        'className': _className(function() {try {return (item.className )} catch(e) {_e(e)}}.call($this)),
        'ref': function() {try {return (!invisible ? ref : undefined )} catch(e) {_e(e)}}.call($this),
        'prevVNode': function() {try {return (currentVNode )} catch(e) {_e(e)}}.call($this),
        'cols': function() {try {return (0 )} catch(e) {_e(e)}}.call($this),
        '_context': $this,
        'ev-click': function() {try {return (item.sortable ? self._sort.bind(self, key, item) : undefined )} catch(e) {_e(e)}}.call($this),
        'ev-dragStart': function() {try {return (dragStart )} catch(e) {_e(e)}}.call($this),
        'ev-$change:value': function() {try {return (self._onChangeGroup.bind(self, key) )} catch(e) {_e(e)}}.call($this)
    })

        tableColumns[layer].push(vNode);

        const props = vNode.props;

        if (loopRecursiveCallback(item, props, layer + 1, item.fixed)) {
            props.rows = 1;
        } else {
            currentVNode = vNode;
            if (/^\d+$/.test(key)) {
                // avoid digital key
                _e(new Error(`don't use digits as key: ${key}.`));
            } else if (_scheme[key]) {
                _e(new Error(`reduplicated key: ${key}`));
            }

            cols.push(h('col', {
        'width': function() {try {return (item.width )} catch(e) {_e(e)}}.call($this),
        'style': function() {try {return ({width: self._getHeaderWidth(key)} )} catch(e) {_e(e)}}.call($this)
    }, null, _className(function() {try {return ({[item.className]: item.className} )} catch(e) {_e(e)}}.call($this))));

            props.cols = 1;
            maxCols++;
            Object.defineProperty(props, 'rows', {
                get() {
                    return maxRows - layer;
                },
                enumerable: true
            });

            // add leaf node to _scheme
            _scheme[key] = props;

            // add to _columns to check width of column
            const oRef = vNode.ref;
            vNode.ref = (i) => {
                if (i) {
                    self._columns[key] = i;
                } else {
                    delete self._columns[key];
                }
                oRef && oRef(i);
            };
        }

        if (parent) {
            parent.cols += props.cols;
            // if child fixed and it will not be invisible
            // parent must not be invisible too
            if (!props.invisible) {
                parent.invisible = false;
            }
        }
    };
    const loopScheme = (scheme, parent, layer, fixed) => {
        let ret = false;
        beforeLoop(layer);
        __u.map(scheme, (item, key) => {
            ret = true;
            loop(item, key, parent, layer, fixed, (item, props, layer, fixed) => {
                if (item.scheme) {
                    return loopScheme(item.scheme, props, layer, fixed);
                }
                return false;
            });
        });
        return ret;
    };
    const loopColumn = (children, parent, layer, fixed) => {
        // add a flag, when we enter to the map callback set it to true
        // because it may have children but is not Column
        let ret = false;
        let beforeLoopDone = false;
        mapChildren(children, vNode => {
            if (vNode.tag === Column) {
                if (!beforeLoopDone) {
                    beforeLoop(layer);
                    beforeLoopDone = true;
                }
                ret = true;
                const props = vNode.props;
                const blockFn = props._blocks && (props._blocks.default || props._blocks.template);
                const _props = {
                    ...props,
                    template: props.template,
                    blockFn,
                };
                loop(_props, props.key, parent, layer, fixed, (item, props, layer, fixed) => {
                    if (item.children) {
                        return loopColumn(item.children, props, layer, fixed);
                    }
                    return false;
                });
            }
        });
        return ret;
    };
    loopScheme(scheme, null, 0);
    // for using TableColumn as children
    loopColumn(children, null, 0);

    // set checkVNode's rowspan
    if (maxRows > 1 && checkVNode) {
        checkVNode.props.rowspan = maxRows;
    } 
    
    const thead = (
        h('div', {
        'style': function() {try {return (do {
                if (onlyLeft) {
                    ({width: self.get('_leftWidth') + 'px'});
                } else if (onlyRight) {
                    ({width: self.get('_rightWidth') + 'px'});
                }
            } )} catch(e) {_e(e)}}.call($this)
    }, h('div', {
        'style': function() {try {return ({paddingRight: self.get('_padding') + 'px'} )} catch(e) {_e(e)}}.call($this)
    }, h('table', {
        'style': function() {try {return (style )} catch(e) {_e(e)}}.call($this)
    }, [
        h('colgroup', null, function() {try {return (cols )} catch(e) {_e(e)}}.call($this)),
        h('thead', null, __m(function() {try {return (tableColumns )} catch(e) {_e(e)}}.call($this), function(value, key) {
            return h('tr', null, function() {try {return (value )} catch(e) {_e(e)}}.call($this));
        }, $this))
    ]), 'k-thead-wrapper'), 'k-thead', null, function() {try {return (refContainer )} catch(e) {_e(e)}}.call($this))
    );

    return _isSticky ? 
        h(Affix, {
        'top': function() {try {return (stickHeader === true ? 0 : +stickHeader )} catch(e) {_e(e)}}.call($this),
        'exclude': function() {try {return (self._excludeStickHeader )} catch(e) {_e(e)}}.call($this),
        'children': function() {try {return (thead )} catch(e) {_e(e)}}.call($this),
        '_context': $this
    }) :
        thead;
};

const TbodyCreator = ({onlyLeft, onlyRight, refContainer, refTable, style}) => {
    // save the rowspan and colspan information
    const grid = [];
    let rowKeys = undefined; // save all rowKey
    let rowCheckeds = undefined; // Save the isChecked of all the rows
    let rowDisableds = undefined;
    let firstCloumnRowSpans = undefined;
    if(merge){
        rowKeys = [];
        rowCheckeds = [];
        rowDisableds = [];
        firstCloumnRowSpans = [];
    }
    let rows;
    if (!data || !data.length) {
        rows = h('tr', null, h('td', {
        'colspan': function() {try {return (maxCols )} catch(e) {_e(e)}}.call($this)
    }, (_blocks['no-data'] = function(parent) {
        return function() {try {return (normalize ? normalize(noDataTemplate) : noDataTemplate )} catch(e) {_e(e)}}.call($this);
    }) && (__blocks['no-data'] = function(parent) {
        var args = arguments;
        return blocks['no-data'] ? blocks['no-data'].apply($this, [function() {
            return _blocks['no-data'].apply($this, args);
        }].concat(__slice.call(args, 1))) : _blocks['no-data'].apply($this, args);
    }) && __blocks['no-data'].apply($this, [__noop]), 'k-no-data'), null, 'table_no_data');
    } else {
        let index = 0;
        rows = [];
        const loop = (data, level, hidden) => {
            data.forEach(value => {
                const children = childrenKey && Array.isArray(value[childrenKey]) ? 
                    value[childrenKey] : null; 

                const key = rowKey.call(self, value, index);
                const disabled = disableRow.call(self, value, index, key);
                const className = rowClassName.call(self, value, index, key);
                const spreaded = self.isSpreaded(key);
                const checked = self.isChecked(key);
                if(merge){
                    rowKeys.push(key);
                    rowCheckeds.push(checked);
                    rowDisableds.push(disabled);
                }
                let tr = h(Animate, {
        'a:tag': function() {try {return (Row )} catch(e) {_e(e)}}.call($this),
        'a:transition': 'c-fade',
        'a:disabled': function() {try {return (!draggable )} catch(e) {_e(e)}}.call($this),
        'key': function() {try {return (key )} catch(e) {_e(e)}}.call($this),
        'rowKey': function() {try {return (key )} catch(e) {_e(e)}}.call($this),
        'value': function() {try {return (value )} catch(e) {_e(e)}}.call($this),
        'index': function() {try {return (index )} catch(e) {_e(e)}}.call($this),
        'className': _className(function() {try {return ({
                        'k-disabled': disabled,
                        [className]: className,
                        'k-checked': checked,
                        'k-hover': _hoverIndex === index, 
                        'k-selected': !disabled && self.isSelected(key),
                        'k-spread': spreaded, 
                        'k-hidden': hidden,
                    } )} catch(e) {_e(e)}}.call($this)),
        'onClick': function() {try {return (self._clickRow )} catch(e) {_e(e)}}.call($this),
        'onDestroy': function() {try {return (self._onRowDestroyed )} catch(e) {_e(e)}}.call($this),
        'onRowEnter': function() {try {return (self._onRowEnter )} catch(e) {_e(e)}}.call($this),
        'onRowLeave': function() {try {return (self._onRowLeave )} catch(e) {_e(e)}}.call($this),
        'onRowDragStart': function() {try {return (self._onRowDragStart )} catch(e) {_e(e)}}.call($this),
        'onRowDragEnd': function() {try {return (self._onRowDragEnd )} catch(e) {_e(e)}}.call($this),
        'onRowDragOver': function() {try {return (self._onRowDragOver )} catch(e) {_e(e)}}.call($this),
        'onToggleSpreadRow': function() {try {return (self._toggleSpreadRow )} catch(e) {_e(e)}}.call($this),
        'onChangeChecked': function() {try {return (self._onChangeChecked )} catch(e) {_e(e)}}.call($this),
        'checkType': function() {try {return (checkType )} catch(e) {_e(e)}}.call($this),
        'onlyRight': function() {try {return (onlyRight )} catch(e) {_e(e)}}.call($this),
        'onlyLeft': function() {try {return (onlyLeft )} catch(e) {_e(e)}}.call($this),
        'disabled': function() {try {return (disabled )} catch(e) {_e(e)}}.call($this),
        'scheme': function() {try {return (_scheme )} catch(e) {_e(e)}}.call($this),
        'merge': function() {try {return (merge )} catch(e) {_e(e)}}.call($this),
        'level': function() {try {return (level )} catch(e) {_e(e)}}.call($this),
        'indent': function() {try {return (indent )} catch(e) {_e(e)}}.call($this),
        'children': function() {try {return (children )} catch(e) {_e(e)}}.call($this),
        'grid': function() {try {return (grid )} catch(e) {_e(e)}}.call($this),
        'checked': function() {try {return (checked )} catch(e) {_e(e)}}.call($this),
        'draggable': function() {try {return (draggable )} catch(e) {_e(e)}}.call($this),
        'dragKey': function() {try {return (_dragKey )} catch(e) {_e(e)}}.call($this),
        'rowKeys': function() {try {return (rowKeys )} catch(e) {_e(e)}}.call($this),
        'rowCheckeds': function() {try {return (rowCheckeds )} catch(e) {_e(e)}}.call($this),
        'rowDisableds': function() {try {return (rowDisableds )} catch(e) {_e(e)}}.call($this),
        'firstCloumnRowSpans': function() {try {return (firstCloumnRowSpans )} catch(e) {_e(e)}}.call($this),
        '_context': $this
    })

                // add tooltip
                if (blocks.tooltip) {
                    const content = (_blocks['tooltip'] = function(parent) {
        return null;
    }) && (__blocks['tooltip'] = function(parent) {
        var args = arguments;
        return blocks['tooltip'] ? blocks['tooltip'].apply($this, [function() {
            return _blocks['tooltip'].apply($this, args);
        }].concat(__slice.call(args, 1))) : _blocks['tooltip'].apply($this, args);
    }) && __blocks['tooltip'].apply($this, [__noop].concat(function() {try {return ([value, index] )} catch(e) {_e(e)}}.call($this)));
                    tr = h(Tooltip, {
        'position': function() {try {return (tooltipPosition )} catch(e) {_e(e)}}.call($this),
        'children': function() {try {return (tr )} catch(e) {_e(e)}}.call($this),
        '_context': $this,
        '_blocks': function(blocks) {
            var _blocks = {}, __blocks = extend({}, blocks);
            return ((_blocks['content'] = function(parent) {
                return function() {try {return (content )} catch(e) {_e(e)}}.call($this);
            }) && (__blocks['content'] = function(parent) {
                var args = arguments;
                return blocks['content'] ? blocks['content'].apply($this, [function() {
                    return _blocks['content'].apply($this, args);
                }].concat(__slice.call(args, 1))) : _blocks['content'].apply($this, args);
            }), __blocks);
        }.call($this, {})
    })
                }

                if (blocks.expand && expandedKeys.indexOf(key) > -1) {
                    tr = [
                        tr,
                        h('tr', null, h('td', {
        'colspan': function() {try {return (maxCols )} catch(e) {_e(e)}}.call($this)
    }, (_blocks['expand'] = function(parent) {
        return null;
    }) && (__blocks['expand'] = function(parent) {
        var args = arguments;
        return blocks['expand'] ? blocks['expand'].apply($this, [function() {
            return _blocks['expand'].apply($this, args);
        }].concat(__slice.call(args, 1))) : _blocks['expand'].apply($this, args);
    }) && __blocks['expand'].apply($this, [__noop].concat(function() {try {return ([value, index] )} catch(e) {_e(e)}}.call($this)))), 'k-expand', function() {try {return (`${key}.expand` )} catch(e) {_e(e)}}.call($this))
                    ]
                }

                index++;
                rows.push(tr);

                // for tree table
                if (children) {
                    loop(value[childrenKey], level + 1, hidden || !spreaded);
                }
            });
        };

        loop(data, 0, false);
    }

    const tbody = h(Animate, {
        'a:tag': 'tbody',
        'a:disabled': function() {try {return (true )} catch(e) {_e(e)}}.call($this),
        'children': function() {try {return (rows )} catch(e) {_e(e)}}.call($this),
        '_context': $this
    })

    return (
        h('div', {
        'style': function() {try {return (do {
                let style;
                if (!_isSticky &&
                    (typeof fixHeader === 'number' || typeof fixHeader === 'string')
                ) {
                    style = {maxHeight: `${fixHeader - (onlyLeft || onlyRight ? _paddingBottom : 0)}px`};
                } 
                /* else if (_isSticky && self.get('_sticky.position')) { */
                    /* style = {paddingTop: self.get('_headerHeight')}; */
                /* } */
                style;
            } )} catch(e) {_e(e)}}.call($this),
        'ev-scroll': function() {try {return (self._onTBodyScroll )} catch(e) {_e(e)}}.call($this)
    }, h('table', {
        'style': function() {try {return (style )} catch(e) {_e(e)}}.call($this)
    }, [
        h('colgroup', null, function() {try {return (cols )} catch(e) {_e(e)}}.call($this)),
        function() {try {return (tbody )} catch(e) {_e(e)}}.call($this)
    ], null, null, function() {try {return (refTable )} catch(e) {_e(e)}}.call($this)), 'k-tbody', null, function() {try {return (refContainer )} catch(e) {_e(e)}}.call($this))
    );
};

const table = (
    h('div', null, [
        h(TheadCreator, {
            'refContainer': function() {try {return (dom => self.header = dom )} catch(e) {_e(e)}}.call($this),
            'style': function() {try {return ({width: self.tableWidth} )} catch(e) {_e(e)}}.call($this),
            '_context': $this
        }),
        h(TbodyCreator, {
            'refContainer': function() {try {return (dom => self.scroll = dom )} catch(e) {_e(e)}}.call($this),
            'refTable': function() {try {return (dom => self.table = dom )} catch(e) {_e(e)}}.call($this),
            'style': function() {try {return ({width: self.tableWidth} )} catch(e) {_e(e)}}.call($this),
            '_context': $this
        })
    ], 'k-table-wrapper')
);

const FixedTable = ({position}) => {
    const tableWidth = self.get('_tableWidth') + 'px';
    const props = {[position === 'left' ? 'onlyLeft' : 'onlyRight']: true};
    const style = {
        width: self.get(`_${position}Width`) + 'px',
    };
    if (!_isSticky && fixHeader === true) {
        style.maxHeight = `calc(100% - ${_paddingBottom}px)`;
    }

    return (
        h('div', {
        'style': function() {try {return (style )} catch(e) {_e(e)}}.call($this)
    }, [
        h(TheadCreator, {
            ...function() {try {return (props )} catch(e) {_e(e)}}.call($this),
            'style': function() {try {return ({width: tableWidth} )} catch(e) {_e(e)}}.call($this),
            '_context': $this
        }),
        h(TbodyCreator, {
            ...function() {try {return (props )} catch(e) {_e(e)}}.call($this),
            'style': function() {try {return ({width: tableWidth} )} catch(e) {_e(e)}}.call($this),
            'refContainer': function() {try {return (i => self[`${position}FixedScroll`] = i )} catch(e) {_e(e)}}.call($this),
            '_context': $this
        })
    ], _className(function() {try {return (`k-table-wrapper k-fixed-${position}` )} catch(e) {_e(e)}}.call($this)))
    );
}

self.hasFixedLeft = hasFixedLeft;
self.hasFixedRight = hasFixedRight;

const classNameObj = {
    'k-table': true,
    [className]: className,
    [`k-${type}`]: type !== 'default',
    'k-sticky': _isSticky, 
    [`k-scroll-${_scrollPosition}`]: _isShowLeftRightMiddle,
    'k-sticky-scrollbar': _isStickyScrollbar,
    'k-stripe': stripe,
    'k-fluid-height': fixHeader === true,
    'k-draggable': draggable,
};

    return h('div', {
        ...function() {try {return (getRestProps(self) )} catch(e) {_e(e)}}.call($this)
    }, [
        function() {try {return (table )} catch(e) {_e(e)}}.call($this),
        function() {try {return (hasFixedLeft )} catch(e) {_e(e)}}.call($this) ?
            h(FixedTable, {
                'position': 'left',
                '_context': $this
            }) :
            undefined,
        function() {try {return (hasFixedRight )} catch(e) {_e(e)}}.call($this) ?
            h(FixedTable, {
                'position': 'right',
                '_context': $this
            }) :
            undefined,
        function() {try {return (_isStickyScrollbar )} catch(e) {_e(e)}}.call($this) ?
            h(Affix, {
                'bottom': function() {try {return (stickScrollbar === true ? 0 : +stickScrollbar )} catch(e) {_e(e)}}.call($this),
                'shouldFix': function() {try {return (self._shouldStickScrollbar )} catch(e) {_e(e)}}.call($this),
                'style': function() {try {return (self.get('_stickyScrollbarStyle') )} catch(e) {_e(e)}}.call($this),
                'children': h('div', {
                    'ev-scroll': function() {try {return (self._onTBodyScroll )} catch(e) {_e(e)}}.call($this)
                }, h('div', {
                    'style': function() {try {return ({width: self.get('_tableWidth') + 'px'} )} catch(e) {_e(e)}}.call($this)
                }, null, 'k-inner'), 'k-scrollbar', null, function(i) {widgets['scrollbar'] = i}),
                '_context': $this
            }) :
            undefined,
        function() {try {return (loading )} catch(e) {_e(e)}}.call($this) ?
            h(Spin, {
                'overlay': function() {try {return (true)} catch(e) {_e(e)}}.call($this),
                'size': 'small',
                '_context': $this
            }) :
            undefined
    ], _className(function() {try {return (classNameObj )} catch(e) {_e(e)}}.call($this)))
}